import { convertToFilter } from "../../../../../../../util";

const initialAddItemFilterValues = {
  _unlocated: false,
};

const toAddItemFilter = values => {
  const filters = convertToFilter({
    values,
    filterKeys: ["_unlocated"],
    skipKeys: ["limit", "offset"],
  });

  return {
    ...filters,
    warehouseMoveLocationId: values._unlocated
      ? { value: null, operator: "isNull" }
      : filters.warehouseMoveLocationId || { value: null, operator: "ne" },
  };
};

export { initialAddItemFilterValues, toAddItemFilter };
